import { Input, Button, Form, Card, Row, Col, Select } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { addUpdateSetting, modifyUpdateSetting } from "./UpdateSettingSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import TextArea from "antd/es/input/TextArea";

export default function AddUpdateSetting(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  React.useEffect(() => {
    if (editBodySize?.id) {
      form.setFieldsValue(editBodySize);
    } else {
      form.resetFields();
    }

  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    if (editBodySize?.id) {
      //form type is edit
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyUpdateSetting(values, editBodySize?.id));
     /*  messageApi.open({
        type: "success",
        content: "Product Type updated successfully",
      }); */
    } else {
      values.created_datetime = new Date().toLocaleString() + "";
      dispatch(addUpdateSetting(values));
      /* messageApi.open({
        type: "success",
        content: "Product Type added successfully",
      }); */
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Card title="iOS" size="small" headStyle={{ backgroundColor: "#018b9826" }}>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label="Version"
                name="ios_version"
                rules={[
                  {
                    required: true,
                    message: "Please enter Version",
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label="Force Update"
                name="ios_force_update"
                rules={[
                  {
                    required: true,
                    message: "Please select Force Update",
                  }
                ]}
              >
                <Select
                  options={[
                    { value: true, label: "true" },
                    { value: false, label: "false" }
                  ]}
                />
              </Form.Item>
            </div>
          </Col>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label="Title"
                name="ios_title"
                rules={[
                  {
                    required: true,
                    message: "Please enter iOS title",
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              label="redirection Link"
              name="ios_redirection_ink"
              rules={[
                {
                  required: true,
                  message: "Please enter redirection Link",
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              label="Message"
              name="ios_message"
              rules={[
                {
                  required: true,
                  message: "Please enter Message",
                }
              ]}
            >
              <TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>

      </Card>

      <Card title="Android" size="small" headStyle={{ backgroundColor: "#018b9826" }} style={{ marginTop: "7px", marginBottom: "7px" }}>


        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label="Version"
                name="android_version"
                rules={[
                  {
                    required: true,
                    message: "Please enter Version",
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label="Force Update"
                name="android_force_update"
                rules={[
                  {
                    required: true,
                    message: "Please select Force Update",
                  }
                ]}
              >
                <Select
                  options={[
                    { value: true, label: "true" },
                    { value: false, label: "false" }
                  ]}
                />
              </Form.Item>
            </div>
          </Col>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label="Title"
                name="android_title"
                rules={[
                  {
                    required: true,
                    message: "Please enter title",
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              label="redirection Link"
              name="android_redirection_ink"
              rules={[
                {
                  required: true,
                  message: "Please enter redirection Link",
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              label="Message"
              name="android_message"
              rules={[
                {
                  required: true,
                  message: "Please enter Message",
                }
              ]}
            >
              <TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>

      </Card>

      <Card title="Common" size="small" headStyle={{ backgroundColor: "#018b9826" }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Active"
              name="common_active"
              rules={[
                {
                  required: true,
                  message: "Please Select",
                }
              ]}
            >
              <Select
                options={[
                  { value: true, label: "true" },
                  { value: false, label: "false" }
                ]}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <div>
              <Form.Item
                label="Title"
                name="common_title"
                rules={[
                  {
                    required: true,
                    message: "Please enter title",
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              label="Message"
              name="common_message"
              rules={[
                {
                  required: true,
                  message: "Please enter Message",
                }
              ]}
            >
              <TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>

      </Card>

      <Form.Item>
        <Button className='submit-button' type="primary" htmlType="submit" >{editBodySize?.id ? 'Update' : 'Create'}</Button>
      </Form.Item>
    </Form>
  );
}
